/**
 * The one default hotbar layout (action-bar plan phase 3): the class's
 * authored default slots, kept to the abilities a new character knows.
 * Character creation (`buildDefaultHotbar`), join repair (`repairHotbar`) and
 * the client's pre-hydration seed (`CharacterFactory`) all read it.
 */
import { DEFAULT_HOTBAR_SLOTS, type DefaultHotbarSlot } from '../content/generated/hotbars.gen';
import { startingKitAbilities } from '../progression/abilityCurve';

export function starterHotbarSlots(heroClass: string): DefaultHotbarSlot[] {
  const classKey = heroClass.toLowerCase();
  const starters = new Set(startingKitAbilities(classKey));
  return (DEFAULT_HOTBAR_SLOTS[classKey] ?? []).filter(entry => Boolean(entry.abilityId && starters.has(entry.abilityId)));
}
